export const DEFAULT_FORBIDDEN_WORDS: string[] = [
  'kostenlos', 'gratis', 'beste', 'bester', 'bestes', 'best',
  'günstigste', 'günstigster', 'günstigstes', 'günstig', 'günstigst',
  'garantiert', 'billig', 'billiger', 'billigste', 'billigsten',
  'free', 'sale', 'rabatt', 'angebot', 'aktion', 'promo',
  'versandkostenfrei', 'top', 'nr.1', 'nummer 1',
  'qualitätsgarantie', 'preisgarantie', 'tiefstpreis',
]

const CHAR_MAX = 200
const ILLEGAL_CHARS = ['!', '?', '$', '%', '*', ':']

export interface TitleValidationResult {
  title: string
  isValid: boolean
  charCount: number
  charMax: number
  repeatedKeywords: string[]
  forbiddenMatches: string[]
  allCapsWords: string[]
  illegalChars: string[]
}

function getRepeatedKeywords(title: string): string[] {
  const words = title.toLowerCase().match(/\b[a-zäöüß]{3,}\b/g) ?? []
  const counts = words.reduce<Record<string, number>>((acc, w) => {
    acc[w] = (acc[w] ?? 0) + 1
    return acc
  }, {})
  return Object.entries(counts)
    .filter(([, n]) => n > 1)
    .map(([w, n]) => `${w}(${n})`)
}

function getForbiddenMatches(title: string, forbiddenWords: string[]): string[] {
  const lower = title.toLowerCase()
  return forbiddenWords.filter((w) => lower.includes(w.toLowerCase()))
}

function getAllCapsWords(title: string): string[] {
  return title.match(/\b[A-ZÄÖÜ]{3,}\b/g) ?? []
}

function getIllegalChars(title: string): string[] {
  return ILLEGAL_CHARS.filter((c) => title.includes(c))
}

export function validateTitle(
  title: string,
  forbiddenWords: string[]
): TitleValidationResult {
  const charCount = title.length
  const repeatedKeywords = getRepeatedKeywords(title)
  const forbiddenMatches = getForbiddenMatches(title, forbiddenWords)
  const allCapsWords = getAllCapsWords(title)
  const illegalChars = getIllegalChars(title)

  const isValid =
    charCount <= CHAR_MAX &&
    repeatedKeywords.length === 0 &&
    forbiddenMatches.length === 0 &&
    allCapsWords.length === 0 &&
    illegalChars.length === 0

  return {
    title, isValid, charCount, charMax: CHAR_MAX,
    repeatedKeywords, forbiddenMatches, allCapsWords, illegalChars,
  }
}
